/**
 * @generated SignedSource<<14a9516115000427f30823a5f6be7ff7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "warp",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "emptyCartByServiceRedirectServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emptyCartByServiceRedirectServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d2f8eb1ecff2a6f8945691adc7026351",
    "id": null,
    "metadata": {},
    "name": "emptyCartByServiceRedirectServiceByIdQuery",
    "operationKind": "query",
    "text": "query emptyCartByServiceRedirectServiceByIdQuery(\n  $id: String\n) {\n  serviceById(id: $id) {\n    id\n    description\n    slug\n    warp\n  }\n}\n"
  }
};
})();

node.hash = "7050af3865652494030d61a6ee23df4f";

module.exports = node;
